/**
 * ConsentVersionPreview (Plan 03-08, 5.0k) — live Markdown preview of the consent
 * text_md being authored. Uses react-markdown + remark-gfm (same render path as the
 * candidate-facing CandidateConsentPage, Plan 03-05).
 *
 * Safelist (5.0k): react-markdown disallows raw HTML by DEFAULT — no <script>,
 * <iframe>, or javascript: URLs render. remark-gfm adds tables + autolinks but does
 * NOT enable raw HTML. No extra sanitizer dependency needed.
 */
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface ConsentVersionPreviewProps {
  textMd: string;
  emptyLabel: string;
}

export function ConsentVersionPreview({
  textMd,
  emptyLabel,
}: ConsentVersionPreviewProps) {
  return (
    <article className="prose prose-sm max-w-none border border-[var(--talenta-border)] rounded p-4 min-h-[200px] bg-[var(--talenta-surface)]">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {textMd || `_${emptyLabel}_`}
      </ReactMarkdown>
    </article>
  );
}
